module.exports = __webpack_public_path__ + "img/motorbike-front-right.eed17c02.svg";